// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34i1J","toggle":"styles_toggle__mVlvs","preview":"styles_preview__lg0Oz"};